import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { urlAppendParam } from 'utils/navigation/tabsHeader.utils';
import './tabsHeader.scss';

const selectClassNames = {
  control: () => 'tabs-header-select-control px-1',
  indicatorSeparator: () => 'd-none',
  menu: () => 'tabs-header-select-menu',
  option: () => 'tabs-header-select-option',
};

const MobileTabsHeader = ({ variant = 'primary', options, param = 'tab' }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const rawParam = searchParams.get(param);

  const selectOptions = options?.map((item) => ({
    label: item.option,
    value: item.option,
  }));
  const activeOption =
    selectOptions?.find((item) => item.value?.toLowerCase() === rawParam?.toLowerCase()) ||
    selectOptions?.[0];

  useEffect(() => {
    if (!activeOption || !rawParam) return;
    if (rawParam === activeOption.value) return;
    navigate(urlAppendParam(param, activeOption.value), { replace: true });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOption?.value, navigate, param, rawParam]);

  return (
    <nav
      aria-label={param === 'tab' ? 'Page sections' : `${param} navigation`}
      className="mobile-tabs-header mt-3"
      data-variant={variant}
    >
      <BaseSelect
        isSearchable
        isClearable={false}
        maxMenuHeight={280}
        classNames={selectClassNames}
        selectProps={{
          'aria-label': param === 'tab' ? 'Page section' : `${param} selection`,
          options: selectOptions,
          value: activeOption ?? null,
          placeholder: 'Choose a section',
          // Keep navigation in the URL so selecting a section also works with Back and Forward.
          onChange: (option) => {
            if (option) navigate(urlAppendParam(param, option.value));
          },
        }}
      />
    </nav>
  );
};

export default MobileTabsHeader;
